// extracted by mini-css-extract-plugin
module.exports = {"table":"styles__table--2Rh4t","universeAddBtn":"styles__universeAddBtn--1oXxR","deleteBtn":"styles__deleteBtn--1EEc3","configTitle":"styles__configTitle--mrN4c"};